import { OrderStep } from 'app/pages/order/redux/model/order-step';
import type { AppDispatch } from 'app/redux/types/types';
import { RequestType } from 'app/pages/order/redux/model/order-request';

import { resetAccountInfoActionCreator } from './reset-account-info-action-creator';
import { updateOrderStepActionCreator } from './update-order-step-action-creator';
import { resetOrderStateActionCreator } from './reset-order-state-action-creator';

export const resetOrderStateForNewAccountActionCreator = () => (dispatch: AppDispatch) => {
    const request: RequestType[] = [RequestType.GET_ACCOUNTS, RequestType.GET_PARTNERS, RequestType.GET_SHOP_STATUS];

    dispatch(updateOrderStepActionCreator(OrderStep.CHOOSE_ACCOUNT));
    dispatch(resetAccountInfoActionCreator());
    dispatch(resetOrderStateActionCreator(request));
};
